var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAIInput',_vm._g(_vm._b({staticClass:"q-mt-sm",attrs:{"value":_vm.value,"large":"","placeholder":_vm.placeholder},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('QIcon',{staticClass:"q-mr-xs",attrs:{"color":"grey-9","size":"22px","name":"eva-person-outline"}})]},proxy:true}])},'SAIInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }